import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { BUSINESS, QUESTIONNAIRE, LOGO_FULL } from "../data/content";
import { Download, Phone, Mail, MapPin, ClipboardList, FileText } from "lucide-react";

export default function QuestionnairePage() {
  return (
    <div className="min-h-screen bg-navy text-white font-body">
      <Navbar />
      <main className="pt-24 pb-24">
        <section className="mx-auto max-w-5xl px-6 lg:px-10">
          {/* Questionnaire header strip */}
          <div className="glass rounded-2xl p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5">
            <div className="flex items-center gap-4">
              <img src={LOGO_FULL} alt="Hylyte Digital" className="h-10 w-auto" />
            </div>
            <div className="flex flex-col gap-1.5 text-sm text-muted">
              <a href={BUSINESS.phoneHref} className="flex items-center gap-2 hover:text-white transition-colors">
                <Phone size={13} className="text-signal" /> {BUSINESS.phone}
              </a>
              <a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-2 hover:text-white transition-colors">
                <Mail size={13} className="text-signal" /> {BUSINESS.email}
              </a>
              <p className="flex items-center gap-2">
                <MapPin size={13} className="text-signal" /> {BUSINESS.address}
              </p>
            </div>
          </div>
          <p className="font-mono text-xs tracking-[0.3em] uppercase text-signal mb-4">// Start a project</p>
          <h1 className="font-display text-4xl md:text-5xl tracking-tighter font-bold">Website project questionnaire</h1>
          <p className="mt-4 text-muted max-w-2xl leading-relaxed">
            Answer a few questions about your business and what you need from your website — we'll come back
            with a plan and a quote. Download the PDF, fill it in, and email it back to us.
          </p>

          {/* Download card */}
          <div className="mt-12 glass rounded-3xl p-8 md:p-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 neon-glow">
            <div className="flex items-start gap-4">
              <span className="grid place-items-center w-12 h-12 rounded-xl bg-signal/10 border border-signal/30 text-signal shrink-0">
                <ClipboardList size={20} />
              </span>
              <div>
                <h2 className="font-display text-xl font-semibold text-white">Print-ready questionnaire (PDF)</h2>
                <p className="text-sm text-muted mt-1">3 pages — business &amp; goals, content &amp; features, details &amp; next steps. Tick boxes and text fields throughout.</p>
              </div>
            </div>
            <a href={QUESTIONNAIRE} download data-testid="download-questionnaire"
              className="inline-flex items-center gap-2 rounded-full bg-signal px-6 py-3 font-semibold text-white hover:bg-signal-hover transition-colors shrink-0">
              <Download size={16} /> Download PDF
            </a>
          </div>

          {/* Contact strip */}
          <div className="mt-12 glass rounded-2xl p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <FileText size={18} className="text-signal" />
              <p className="text-sm text-muted">Send your completed questionnaire to</p>
            </div>
            <div className="flex flex-wrap items-center gap-6 text-sm">
              <a href={`mailto:${BUSINESS.email}?subject=Website%20questionnaire`} className="flex items-center gap-2 text-white hover:text-signal transition-colors">
                <Mail size={14} className="text-signal" /> {BUSINESS.email}
              </a>
              <a href={BUSINESS.phoneHref} className="flex items-center gap-2 text-white hover:text-signal transition-colors">
                <Phone size={14} className="text-signal" /> {BUSINESS.phone}
              </a>
            </div>
          </div>
        </section>
      </main>

      {/* Questionnaire footer strip */}
      <div className="border-t border-white/10 bg-navy-light/40">
        <div className="mx-auto max-w-5xl px-6 lg:px-10 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <img src={LOGO_FULL} alt="Hylyte Digital" className="h-9 w-auto" />
          </div>
          <div className="flex flex-col sm:items-end gap-2 text-sm">
            <div className="flex flex-wrap items-center gap-5 text-muted">
              <a href={BUSINESS.phoneHref} className="flex items-center gap-2 hover:text-white transition-colors">
                <Phone size={13} className="text-signal" /> {BUSINESS.phone}
              </a>
              <a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-2 hover:text-white transition-colors">
                <Mail size={13} className="text-signal" /> {BUSINESS.email}
              </a>
              <p className="flex items-center gap-2">
                <MapPin size={13} className="text-signal" /> {BUSINESS.address}
              </p>
            </div>
            <a href={QUESTIONNAIRE} download data-testid="download-questionnaire-footer"
              className="inline-flex items-center gap-2 rounded-full bg-signal px-6 py-3 font-semibold text-white hover:bg-signal-hover transition-colors mt-2">
              <Download size={15} /> Download questionnaire (PDF)
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
